import { render, staticRenderFns } from "./EditorCounter.vue?vue&type=template&id=319e2144&"
import script from "./EditorCounter.vue?vue&type=script&lang=js&"
export * from "./EditorCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports